import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';

export type NodeParentType =
HierarchyLevelType.Country | HierarchyLevelType.Field | HierarchyLevelType.Site |
HierarchyLevelType.Well | HierarchyLevelType.Wellbore | HierarchyLevelType.Node;

export enum HierarchyItemStates {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}
